<div *ngIf="successMessage" class="alert alert-success" role="alert">
	<mat-icon>thumb_up</mat-icon> &nbsp;
	<span style="vertical-align: text-bottom; margin-bottom: 0rem;">
		{{successMessage}}
	</span>
</div>

<div *ngIf="errorMessage" class="alert alert-danger" role="alert">

	<span style="vertical-align: text-bottom; margin-bottom: 0rem;">
		{{errorMessage}}
	</span>
</div>


<div class="row_1">
	<div class="top_grid_agg">
		<div class="row justify-content-center">
			<div class="content">
				<div style="width: 50%; justify-content: left; display: flex;">
					<button routerLink="/board" class="back_button col-sm-1">BACK</button>
				</div>
				<div style="width: 50%; justify-content: right; display: flex;">
					<button class="add_button col-sm-1 float-right" (click)="addtask()">SAVE</button>
				</div>
			</div>
		</div>
		<div class="period-form">
			<form class="form-horizontal hr">
				<div class="form-group row">
					<div class="col-sm-6">

						<div class="board-row">
							<label class="control-label col-sm-4">Board:
								<span style="color:#ff0000">*</span>
							</label>
							<div class="col-sm-8">

								<div class="board">
									{{boardDescription}}
								</div>

							</div>
						</div>

						<div class="task-row">
							<label class="control-label col-sm-4">Task:
								<span style="color:#ff0000">*</span>
							</label>
							<div class="col-sm-8">

								<div class="task">
									{{taskDescription}}
								</div>


							</div>
						</div>
						<div class="dDay-row">
							<label class="control-label col-sm-4">Due Date:
								<span style="color:#ff0000">*</span>
							</label>
							<div class="col-sm-8">
								<input type="datetime-local" [(ngModel)]="selected_duedate"
									[ngModelOptions]="{standalone: true}">
							</div>
						</div>



						<div class="sequence-row">
							<label class="control-label col-sm-4">Sequence:</label>
							<div class="col-sm-8">
								<input type="number" min="0" max="99" [(ngModel)]="selected_sequence"
									[ngModelOptions]="{standalone: true}">
							</div>
						</div>

						<div class="primaryuser-row">
							<label class="control-label col-sm-4">Primary User:
								<span *ngIf="s_region_flag" style="color:#ff0000">*</span>
							</label>
							<div class="col-sm-8">
								<input type="text" matInput [matAutocomplete]="auto" placeholder="Select" [(ngModel)]="selected_puser"
									[ngModelOptions]="{ standalone: true }" (input)="filterUsers($event.target.value)" />
								
								<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected_puser = $event.option.value">
									<mat-option *ngFor="let user of filteredUsers" [value]="user.label">
										{{ user.label }}
									</mat-option>
								</mat-autocomplete>
								
								<button *ngIf="selected_puser" matSuffix mat-icon-button aria-label="Clear" (click)="selected_puser = null">
									<mat-icon>close</mat-icon>
								</button>

							</div>
						</div>

						<div class="secondaryuser-row">
							<label class="control-label col-sm-4">Secondary User:</label>
							<div class="col-sm-8">
								<mat-select [(ngModel)]="selected_suser" [compareWith]="compareRegion" [ngModelOptions]="{ standalone: true }" placeholder="Select" disableRipple name="suser">
									<mat-select-trigger>
										{{ selected_suser?.label || 'Select' }}
									</mat-select-trigger>
								
									<!-- Filter input inside dropdown -->
									<mat-option>
										<input type="text" placeholder="Filter..." (click)="$event.stopPropagation()"
											(input)="filterSUsers($event.target.value)" style="width: 100%; padding: 4px; box-sizing: border-box;" />
									</mat-option>
								
									<!-- Render filtered options -->
									<mat-option *ngFor="let user of filteredSUserOptions" [value]="user">
										{{ user.label }}
									</mat-option>
								</mat-select>
							</div>
						</div>

					</div>
					<div class="col-sm-6">

						<div class="region-row">
							<label class="control-label col-sm-4 " for="fname">Region:
								<span *ngIf="!selected_puser" style="color:#ff0000">*</span>
							</label>
							<div class="multiselect col-sm-8">
								
								<mat-select
								[(ngModel)]="selected_region" name="region" 
								[ngModelOptions]="{ standalone: true }"
								multiple [compareWith]="compareRegion"
								placeholder="Select Region(s)"
								(selectionChange)="flagFunc()"
							  >
								<!-- Filter box -->
								<mat-option>
								  <input
									type="text"
									placeholder="Filter..."
									(click)="$event.stopPropagation()"
									(input)="filterRegions($event.target.value)"
									style="width: 100%; padding: 4px; box-sizing: border-box;"
								  />
								</mat-option>
							
								<!-- Filtered region options -->
								<mat-option
								  *ngFor="let region of filteredRegions"
								  [value]="region"
								>
								  {{ region.label }}
								</mat-option>
							  </mat-select>

							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
		<!-- <div class="grid-footer col-sm-12 ">
			<button routerLink="/board" class="back-button col-sm-1">Back</button>
			<button class="add-button col-sm-1 float-right" (click)="addtask()"> Save</button>

		</div> -->
	</div>
</div>